import React from "react";
import "./StatsBar.css";

const STATS = [
  { title: "100%", text: "Explainable AI decisions" },
  { title: "Full audit", text: "Every action logged" },
  { title: "SOC 2 ready", text: "GDPR-aligned architecture" },
  { title: "Role-based", text: "Access on every workflow" },
];

export default function StatsBar({ className = "" }) {
  return (
    <section className={`stats-bar ${className}`.trim()} aria-label="Platform highlights">
      <ul>
        {STATS.map((item) => (
          <li key={item.title}>
            <strong>{item.title}</strong>
            <span>{item.text}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
